import React, { useEffect, useState } from 'react';
import { arrayOf, shape, string, func, object, bool } from 'prop-types';
import { NamedLink, IconArrowHead } from '../../../..';
import classNames from 'classnames';



// shared
import { isConflictingItems, NEW_ARRIVAL_KEY, VIEW_ALL_KEY } from '../TopbarDropdownMenu.helpers';
import DropdownSubItems from '../DropdownSubItems/DropdownSubItems';
import css from './Dropdown.module.css';
import { VIRTUAL_CATEGORY_GROUPS } from '../../../../../config/marketplace-custom-config';


// Define constants for arrow position
const DROPDOWN_ITEM_ARROW_POSITION = 'right';

/**
 * Component that shows the single dropdown item.
 */
const DropdownListItem = props => {
  const { item, isBrand } = props;

  // local expand state for inline accordion
  const [expanded, setExpanded] = useState(false);

  // build submenu options (your current logic kept)
  const label = item.label;
  let subMenuOptions = [];

  if (Array.isArray(item.options) && item.options.length) {
    subMenuOptions = item.options.filter(o => o.key !== VIEW_ALL_KEY);
  }

  if (!subMenuOptions.length && Array.isArray(item.subCategories)) {
    subMenuOptions = item.subCategories;
  }

  if (!subMenuOptions.length && VIRTUAL_CATEGORY_GROUPS[item.key]) {
    subMenuOptions = VIRTUAL_CATEGORY_GROUPS[item.key].map(subKey => ({
      key: subKey,
      label: subKey.replace(/-/g, ' ')
    }));
  }

  const hasOptions = subMenuOptions.length > 0;

    // search link:
  // - brands: filter by pub_brand
  // - categories: filter by pub_category AND pub_subcategory (e.g. dog-food)
  // Determine the correct top-level category (dog, cat, otherPets)
  const parentCategory = item.category || null;


  // Build the search URL
  // Build correct search URL for categories
  let toSearch = '';

  // ✅ BRAND (never touch category)
  if (isBrand === true) {
    toSearch = `pub_brand=${item.key}`;
  }

  // ✅ CATEGORY (only if category exists)
  if (isBrand === false && parentCategory) {
    if (VIRTUAL_CATEGORY_GROUPS[item.key]) {
      const leafKeys = VIRTUAL_CATEGORY_GROUPS[item.key];
      toSearch = `pub_category=${parentCategory}&pub_subcategory=has_any:${leafKeys.join(',')}`;
    } else {
      toSearch = `pub_category=${parentCategory}&pub_subcategory=${item.key}`;
    }
  }




  // ... inside DropdownListItem component

return (
  <li className={css.dropdownListItem}>
    
    {/* START: NEW HEADER WRAPPER (This keeps link and arrow on one line) */}
    <div className={css.dropdownItemHeader}>
        
        {/* LEFT = category link (The main label) */}
        <NamedLink
          className={css.dropdownListItemLink}
          name="SearchPage"
          to={{ search: toSearch }}
        >
          {label}
        </NamedLink>

        {/* RIGHT = expand arrow */}
        {hasOptions && (
          <button
            className={css.expandButton}
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              setExpanded(!expanded);
            }}
          >
            <IconArrowHead
              className={expanded ? css.arrowOpen : css.arrowClosed}
              direction="right"
            />
          </button>
        )}
    </div>
    {/* END: NEW HEADER WRAPPER */}


    {/* INLINE SUBMENU (This will now appear BELOW the header, fixing the sidebar issue) */}
    {expanded && !isBrand&& (
      <ul className={css.submenuList}>
        {subMenuOptions.map(sub => (
          <li key={sub.key}>
            <NamedLink
              className={css.submenuItem}
              name="SearchPage"
              to={{ search: `pub_category=${item.category}&pub_subcategory=${sub.key}` }}
            >
              {sub.label}
            </NamedLink>
          </li>
        ))}
      </ul>
    )}


  </li>
);
// ...
};


DropdownListItem.defaultProps = {
  item: null,
  activeDropdownIndex: null,
  setActiveDropdownIndex: null,
  isBrand: false,
};

DropdownListItem.propTypes = {
  item: object,
  activeDropdownIndex: string,
  setActiveDropdownIndex: func.isRequired,
  isBrand: bool.isRequired,
};

const BrandDropdownList = props => {
  const { options, activeDropdownIndex, setActiveDropdownIndex } = props;

  const AGbrands = options.filter(i => i.type === 'A-G');
  const GMbrands = options.filter(i => i.type === 'G-M');
  const NRbrands = options.filter(i => i.type === 'N-R');
  const SZbrands = options.filter(i => i.type === 'S-Z');

  const brands = [AGbrands, GMbrands, NRbrands, SZbrands];
  return (
    <div className={css.dropdownGridList}>
      {brands.map((b, index) => {
        return (
          <ul key={index} className={css.dropdownList}>
            <li className={css.dropdownListItem}>
              <span className={css.dropdownListItemType}>{b[0]?.type || ''}</span>
            </li>
            {b.map(i => {
              return (
                <DropdownListItem
                  key={i.key}
                  item={i}
                  options={i.options || []}
                  activeDropdownIndex={activeDropdownIndex}
                  setActiveDropdownIndex={setActiveDropdownIndex}
                  isBrand={true}
                

                />
              );
            })}
          </ul>
        );
      })}
    </div>
  );
};

/**
 * Component that shows the dropdown list.
 */
const DropdownList = props => {
  const {
  option,
  options,
  activeDropdownIndex,
  setActiveDropdownIndex,
  } = props;

 
  const isDogItem = option.key === 'dog';

  return (
    <ul className={css.dropdownList}>
      
      {options
        // .sort((o1, o2) => {
        //   // Assign priority levels
        //   const getPriority = key => {
        //     if (key === VIEW_ALL_KEY) return 0; // View All comes first
        //     if (key === NEW_ARRIVAL_KEY) return 1; // New Arrival comes second
        //     return 2; // Others come last
        //   };

        //   const priority1 = getPriority(o1.key);
        //   const priority2 = getPriority(o2.key);

        //   // Sort by priority first
        //   if (priority1 !== priority2) {
        //     return priority1 - priority2;
        //   }

        //   // If both have the same priority (normal items), sort alphabetically
        //   return o1.label.localeCompare(o2.label);
        // })
        .map(i => {
          const isLittersItem = i.key === 'litters';
          if (isDogItem && isLittersItem) {
            return null;
          }
          return (
            <DropdownListItem
              key={i.key}
              item={i}
              options={i.options || []}
              activeDropdownIndex={activeDropdownIndex}
              setActiveDropdownIndex={setActiveDropdownIndex}
              isBrand={false}
            
            />

          );
        })}
    </ul>
  );
};

DropdownList.defaultProps = {
  options: [],
  activeDropdownIndex: null,
  setActiveDropdownIndex: null,
};

DropdownList.propTypes = {
  options: arrayOf(
    shape({
      key: string.isRequired,
      label: string.isRequired,
    })
  ),
  activeDropdownIndex: string,
  setActiveDropdownIndex: func.isRequired,
};

/**
 * Component that shows the dropdown.
 */
const Dropdown = props => {
  let { rootClassName, className, option, isBrand, options: originalOptions, ...rest } = props;
  originalOptions = originalOptions.map((ob, index) => ({
  ...ob,
  numbering: index + 1,
  options: ob.options || [],
}));


  const classes = classNames(rootClassName || className, css.root, {
    [css.brandRoot]: isBrand,
  });

  // Define the active dropdown index
  const [activeDropdownIndex, setActiveDropdownIndex] = useState(null);



  

  return (
  <div className={`${classes} ${css.dropdownPanel}`}>
      {isBrand ? (
        <BrandDropdownList
          activeDropdownIndex={activeDropdownIndex}
          setActiveDropdownIndex={setActiveDropdownIndex}
          options={originalOptions}
          {...rest}
        />
      ) : (
        <DropdownList
          option={option}
          activeDropdownIndex={activeDropdownIndex}
          setActiveDropdownIndex={setActiveDropdownIndex}
          options={originalOptions}       // ✅ FULL LIST, NO PAGING
          {...rest}
        />
      )}
  </div>
);

};

DropdownSubItems.defaultProps = {
  rootClassName: null,
  className: null,
  isBrand: false,
};

DropdownSubItems.propTypes = {
  rootClassName: string,
  className: string,
  option: object,
  isBrand: bool.isRequired,
};

export default Dropdown;
